import { createStore }     from 'redux';
import { combineReducers } from 'redux-immutable';
import applicationReducer  from './applicationReducer';

export default createStore(combineReducers({
    app      : applicationReducer,
}));
